import analytics from "../../utils/analytics";


// The column indexes are based on how
// the columns are rendered in FoldersTable.reshapeDataForTable() func.
export const CREATIONDATECOLUMNINDEX = 4;
export const UPDATEDATECOLUMNINDEX = 5;

/**
 * Customize the table using the options object
 */
export function getTableOptions(shownFolderCount, history, matchedComponentName) {
	return {
		selectableRows: false,
		rowsPerPage: shownFolderCount,
		rowsPerPageOptions: [100, 250, 500],
		elevation: 1,
		print: false,
		viewColumns: false,
		fixedHeaderOptions: {
			xAxis: false,
			yAxis: true
		},
		setTableProps: () => ({ id: "folders-datatable" }),
		customSort: (data, dataIndex, rowIndex) => {
			if (
				dataIndex === CREATIONDATECOLUMNINDEX ||
				dataIndex === UPDATEDATECOLUMNINDEX
			) {
				return sortColumnByDate(data, dataIndex, rowIndex);
			} else {
				return sortDefault(data, dataIndex, rowIndex);
			}
		},
		onRowClick: (rowData, rowState) => {
			const folderIdIndex = 7; //Based on the column order in reshapeDataForTable()
			const folderId = rowData[folderIdIndex];
			history.push(`#!/folders/${folderId}`);
		},
		onChangePage: () => {
			let tableOuterDiv = document.getElementById("folders-datatable")
				.parentElement;
			tableOuterDiv.scrollTop = 0;
		},
		onDownload: () => {
			analytics.logEvent(analytics.eventTypes.FOLDERS.DOWNLOAD_CSV_CLICKED, {
				smartView: matchedComponentName
			});
		},
		onFilterChange: (changedColumn) => {
			analytics.logEvent(analytics.eventTypes.FOLDERS.FILTER_FOLDERS_CLICKED, {
				filteredColumn: changedColumn,
				smartView: matchedComponentName
			});
		},
		onSearchOpen: () => {
			analytics.logEvent(analytics.eventTypes.FOLDERS.FOLDER_SEARCH_CLICKED, {
				smartView: matchedComponentName
			});
		},
		onChangeRowsPerPage: (selectedRowsPerPage) => {
			analytics.logEvent(analytics.eventTypes.FOLDERS.PAGINATION_OPTION_CLICKED, {
				smartView: matchedComponentName,
				rowsPerPage: selectedRowsPerPage
			});
		},
		onColumnSortChange: (changedColumn) => {
			analytics.logEvent(analytics.eventTypes.FOLDERS.SORT_FOLDERS_CLICKED, {
				sortedColumn: changedColumn,
				smartView: matchedComponentName
			});
		}
	};
}

/**
 * Sorts a Datetime column (asc and desc)
 * @param {*} data Column
 * @param {*} dataIndex Column cell index
 * @param {*} rowIndex Sort asc or desc
 */
export function sortColumnByDate(data, dataIndex, rowIndex) {
	return data.sort((a, b) => {
		const dateA = new Date(a.data[dataIndex]).getTime();
		const dateB = new Date(b.data[dataIndex]).getTime();
		return (dateA < dateB ? -1 : 1) * (rowIndex === "desc" ? -1 : 1);
	});
}

/**
 * Sorts a column using the default JS sort algorithm
 * @param {*} data Column
 * @param {*} dataIndex Column cell index
 * @param {*} rowIndex Sort asc or desc
 */
export function sortDefault(data, dataIndex, rowIndex) {
	return data.sort((a, b) => {
		let firstData = a.data[dataIndex];
		let secondData = b.data[dataIndex];
		firstData = typeof (firstData) === "string" ? firstData.toLowerCase() : firstData;
		secondData = typeof (secondData) === "string" ? secondData.toLowerCase() : secondData;

		return (
			(firstData < secondData ? -1 : 1) * (rowIndex === "desc" ? -1 : 1)
		);
	});
}

/**
 * Returns an array of objects describing the table columns
 * Options to customize each columns go here
 */
export function getTableColumns(colStyles) {
	return [
		{
			name: "thumbnail",
			label: "Thumbnail",
			options: {
				filter: false,
				sort: false,
				download: false,
				// Override the column header text opacity to not show the name
				setCellHeaderProps: () => ({
					style: { color: "rgba(0, 0, 0, 0)" }
				})
			}
		},
		{
			name: "star",
			label: "Star",
			options: {
				filter: false,
				sort: false,
				download: false,
				// Override the column header text opacity to not show the name
				setCellHeaderProps: () => ({
					style: { color: "rgba(0, 0, 0, 0)" }
				})
			}
		},
		{
			name: "name",
			label: "Name",
			options: {
				filter: false,
				sort: true,
				setCellHeaderProps: () => colStyles,
				//override the name cells to be bold
				setCellProps: () => ({
					style: { fontWeight: 700 }
				})
			}
		},
		{
			name: "creator",
			label: "Creator",
			options: {
				filter: true,
				sort: true,
				setCellHeaderProps: () => colStyles
			}
		},
		{
			name: "creation_date",
			label: "Creation Date",
			options: {
				filter: false,
				sort: true,
				sortDirection: "desc",
				setCellHeaderProps: () => colStyles
			}
		},
		{
			name: "last_updated",
			label: "Last Updated",
			options: {
				filter: false,
				sort: true,
				setCellHeaderProps: () => colStyles
			}
		},
		{
			name: "items",
			label: "Items",
			options: {
				filter: false,
				sort: true,
				setCellHeaderProps: () => colStyles
			}
		},
		{
			name: "id",
			label: "Id",
			options: {
				display: false,
				filter: false,
				sort: false,
				setCellHeaderProps: () => colStyles
			}
		}
	];
}
